import validator from 'validator';
import FormValidator from './FormValidator';

const trans = window.trans;

export default new FormValidator([
    {
        field: 'email',
        method: validator.isEmpty,
        validWhen: false,
        message: trans.error_email_empty,
    },
    {
        field: 'name',
        method: validator.isEmpty,
        validWhen: false,
        message: trans.error_name_empty,
    },
    {
        field: 'phone',
        method: validator.isEmpty,
        validWhen: false,
        message: trans.error_phone_empty,
    },
    {
        field: 'email',
        method: validator.isEmail,
        validWhen: true,
        message: trans.error_email_invalid,
    },
    {
        field: 'phone',
        method: validator.isMobilePhone,
        args: ['any'],
        validWhen: true,
        message: trans.error_phone_invalid,
    },
]);



// WEBPACK FOOTER //
// ./scripts/util/validators/BookingFormValidator.js